import { Card, Col, Row, Table, Typography } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";
import { Severty, ShowToast } from "../../helper/toast";

const { Title } = Typography;

function Home() {
  const { request } = useRequest();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dashboard, setDashboard] = useState({
    clients: 0,
    activeVendors: 0,
    admins: 0,
    ops: 0,
    ordersInProgress: 0,
    transactions: [],
    revenueYTD: 0,
  });

  // Fetch dashboard data
  // const fetchDashboardData = () => {
  //   setLoading(true);
  //   request({
  //     url: apiPath.dashboard,
  //     method: "GET",
  //     onSuccess: (data) => {
  //       setLoading(false);
  //       if (data.status) {
  //         console.log("Dashboard API Response:", data); // Debug
  //         setDashboard({
  //           clients: data.data.clients || 0,
  //           activeVendors: data.data.activeVendors || 0,
  //           admins: data.data.admins || 0,
  //           ops: data.data.ops || 0,
  //           ordersInProgress: data.data.ordersInProgress || 0,
  //           transactions: Array.isArray(data.data.transactions) ? data.data.transactions : [],
  //           revenueYTD: data.data.revenueYTD ?? 0,
  //         });
  //       } else {
  //         ShowToast(data.message || "Failed to fetch dashboard data", Severty.ERROR);
  //       }
  //     },
  //     onError: (error) => {
  //       setLoading(false);
  //       ShowToast(error.message || "Error fetching dashboard data", Severty.ERROR);
  //     },
  //   });
  // };

  // useEffect(() => {
  //   fetchDashboardData();
  // }, []);

  // Navigation handlers
  // const handleCardClick = (path) => {
  //   navigate(path);
  // };

  // Updated Table columns to match VendorTransaction API
//   const transactionColumns = [
//   {
//     title: "Transaction ID",
//     dataIndex: "transaction_id",
//     key: "transaction_id",
//     render: (text) => text || "-",
//   },
//   {
//     title: "Date",
//     dataIndex: "created_at",
//     key: "created_at",
//     render: (text) => (text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : "-"),
//   },
//   {
//     title: "Amount",
//     dataIndex: "amount",
//     key: "amount",
//     render: (text) => (text ? `$${parseFloat(text).toFixed(2)}` : "-"),
//   },
//   {
//     title: "Client",
//     dataIndex: "client_name",
//     key: "client_name",
//     render: (text) => text || "-",
//   },
//   {
//     title: "Vendor",
//     dataIndex: "vendor_name",
//     key: "vendor_name",
//     render: (text) => text || "-",
//   },
//   {
//     title: "Status",
//     dataIndex: "status",
//     key: "status",
//     render: (status) => {
//       if (!status) return <span style={{ color: "#999" }}>-</span>;

//       const normalized = status.toLowerCase().trim();
//       const colorMap = {
//         approved: "#52c41a",
//         rejected: "#ff4d4f",
//         on_hold: "#faad14",
//         under_review: "#722ed1",
//         pending: "#1890ff",
//       };

//       const bgColor = colorMap[normalized] || "#d9d9d9";
//       const displayText = status
//         .replace(/_/g, " ")
//         .replace(/\b\w/g, (l) => l.toUpperCase());

//       return (
//         <span
//           style={{
//             display: "inline-block",
//             padding: "4px 10px",
//             borderRadius: 12,
//             backgroundColor: bgColor,
//             color: "#fff",
//             fontSize: 11,
//             fontWeight: "bold",
//             textTransform: "uppercase",
//             minWidth: 70,
//             textAlign: "center",
//           }}
//         >
//           {displayText}
//         </span>
//       );
//     },
//   },
// ];

  // return (
  //   <div className="layout-content">
  //     <Row gutter={[24, 24]}>
  //       {/* Top Row: Clients, Active Vendors, Admins, Ops */}
  //       <Col xs={24}>
  //         <Title level={3}>Dashboard Stats</Title>
  //         <Row gutter={[24, 24]}>
  //           <Col xs={24} sm={12} md={6}>
  //             <Card
  //               className="count-card"
  //               hoverable
  //               onClick={() => handleCardClick("/users")}
  //             >
  //               <h6>No. of Clients</h6>
  //               <h2>{dashboard.clients}</h2>
  //             </Card>
  //           </Col>
  //           <Col xs={24} sm={12} md={6}>
  //             <Card
  //               className="count-card"
  //               hoverable
  //               onClick={() => handleCardClick("/vendors")}
  //             >
  //               <h6>No. of Active Vendors</h6>
  //               <h2>{dashboard.activeVendors}</h2>
  //             </Card>
  //           </Col>
  //           <Col xs={24} sm={12} md={6}>
  //             <Card
  //               className="count-card"
  //               hoverable
  //               onClick={() => handleCardClick("/admin-user")}
  //             >
  //               <h6>No. of Admins</h6>
  //               <h2>{dashboard.admins}</h2>
  //             </Card>
  //           </Col>
  //           <Col xs={24} sm={12} md={6}>
  //             <Card
  //               className="count-card"
  //               hoverable
  //               onClick={() => handleCardClick("/ops")}
  //             >
  //               <h6>No. of Ops</h6>
  //               <h2>{dashboard.ops}</h2>
  //             </Card>
  //           </Col>
  //         </Row>
  //       </Col>

  //       {/* Middle Row: Orders in Progress and Revenue YTD */}
  //       <Col xs={24}>
  //         <Row gutter={[24, 24]} className="mb-3">
  //           <Col xs={24} sm={12} md={12}>
  //             <Card
  //               className="count-card"
  //               hoverable
  //               onClick={() => handleCardClick("/order-list")}
  //             >
  //               <h6>NO. of Orders in Progress</h6>
  //               <h2>{dashboard.ordersInProgress}</h2>
  //             </Card>
  //           </Col>
  //           <Col xs={24} sm={12} md={12}>
  //             <Card
  //               className="count-card"
  //               hoverable
  //               onClick={() => handleCardClick("/order")}
  //             >
  //               <h6>Revenue YTD</h6>
  //               <h2>
  //                 {typeof dashboard.revenueYTD === "number"
  //                   ? `$${dashboard.revenueYTD.toFixed(2)}`
  //                   : "-"}
  //               </h2>
  //             </Card>
  //           </Col>
  //         </Row>
  //       </Col>

  //       {/* Bottom Section: Recent Transactions */}
  //       <Col xs={24}>
  //         <Title level={3}>Recent Transactions</Title>
  //         <Card>
  //           <Table
  //             columns={transactionColumns}
  //             dataSource={dashboard.transactions.slice(0, 10)}
  //             rowKey="id"
  //             pagination={false}
  //             loading={loading}
  //             onRow={(record) => ({
  //               onClick: () => handleCardClick(`/transactions`),
  //               style: { cursor: "pointer" },
  //             })}
  //           />
  //         </Card>
  //       </Col>
  //     </Row>
  //   </div>
  // );
}

export default Home;